import React, { memo, useState, useCallback, useEffect } from 'react'
import { Collapse } from 'antd'
import { useMediaQuery } from 'react-responsive'
import { FieldGroupProps } from './types'
import { GroupWrapper, StyledCollapse } from './styles'

export const FieldGroup: React.FC<FieldGroupProps> = memo(props => {
  const {
    title,
    children,
    isFirst = false,
    className,
    mobileBreakpoint = 768,
    forceOpen,
    onToggle,
  } = props

  const isMobile = useMediaQuery({ maxWidth: mobileBreakpoint })

  const defaultOpen = !isMobile || isFirst
  const [activeKeys, setActiveKeys] = useState<string[]>(defaultOpen ? ['panel'] : [])

  useEffect(() => {
    if (forceOpen !== undefined) {
      setActiveKeys(forceOpen ? ['panel'] : [])
    } else if (!isMobile) {
      setActiveKeys(['panel'])
    } else if (isFirst) {
      setActiveKeys(['panel'])
    }
  }, [isMobile, isFirst, forceOpen])

  const handleChange = useCallback(
    (keys: string | string[]) => {
      if (!isMobile) return
      const keysArray = Array.isArray(keys) ? keys : [keys]
      setActiveKeys(keysArray)
      const isOpen = keysArray.includes('panel')
      onToggle?.(isOpen)
    },
    [isMobile, onToggle],
  )

  if (isMobile) {
    return (
      <GroupWrapper $isMobile={isMobile} $isFirst={isFirst} className={className}>
        <StyledCollapse ghost activeKey={activeKeys} onChange={handleChange}>
          <Collapse.Panel header={title} key="panel">
            {children}
          </Collapse.Panel>
        </StyledCollapse>
      </GroupWrapper>
    )
  }

  return (
    <GroupWrapper $isMobile={isMobile} $isFirst={isFirst} className={className}>
      <div style={{ fontWeight: 600, fontSize: '16px', marginBottom: '12px' }}>{title}</div>
      {children}
    </GroupWrapper>
  )
})

FieldGroup.displayName = 'FieldGroup'
